// Projekt-database for Tømrerfirmaet Fyr og Finér ApS.
// Hvert nyt projekt tilføjes her — siderne genereres automatisk.
//
// Felter:
//   slug            Unikt ID i URL (kun små bogstaver, bindestreg)
//   title           Projektets titel
//   subtitle        Kort undertitel / lokation
//   category        Kategori (fx "Renovering", "Tagarbejde")
//   year            Årstal
//   summary         Kort beskrivelse til oversigten (1-2 linjer)
//   description     Længere tekst til underside (array af afsnit)
//   cover           Hovedbillede (URL)
//   gallery         Ekstra billeder (array af URLs)
//   facebookUrl     Link til det oprindelige Facebook-opslag
//   instagramUrl    Link til det oprindelige Instagram-opslag
//   featured        true hvis det skal vises på forsiden

export const projects = [
    {
        slug: "velux-ovenlysvinduer",
        title: "Fire nye VELUX i taget",
        subtitle: "Privatbolig · Montage",
        category: "Tag & ovenlys",
        year: "2025",
        summary:
            "Fire VELUX ovenlysvinduer monteret på en uge — mere dagslys helt ind i huset og taget lukket pænt omkring.",
        description: [
            "Fire stk. VELUX monteret i denne uge. Så kom der både mere lys ind og endnu en opgave sikkert i mål.",
            "Der er noget tilfredsstillende ved at se taget lukke pænt omkring de nye ovenlysvinduer — inddækningerne ligger, som de skal, undertaget er ført op omkring karmen, og kunden får dagslys helt ind i huset fra første dag.",
            "Tagarbejde er lige dele håndværk og vejrforståelse. Når vi åbner et tag, bliver det lukket igen samme dag, og alt bliver gjort så det holder tæt — også når det blæser sidelæns med regn.",
        ],
        cover: "https://customer-assets.emergentagent.com/job_markus-toemrer/artifacts/2b8ksmfh_672030435_122145153236995551_7658058148940606720_n.jpg",
        gallery: [
            "https://customer-assets.emergentagent.com/job_markus-toemrer/artifacts/hz23uhe8_672324713_122145153230995551_5056712114805173279_n.jpg",
            "https://customer-assets.emergentagent.com/job_markus-toemrer/artifacts/ouyqidkm_672678972_122145153242995551_5827845783074710136_n.jpg",
        ],
        facebookUrl: "https://web.facebook.com/share/p/1Awr8gmdyu/",
        instagramUrl: "https://www.instagram.com/fyrogfiner/",
        featured: true,
    },
    {
        slug: "traeterrasse-udesaeson",
        title: "Træterrasse klar til udesæsonen",
        subtitle: "Privatbolig · Nordsjælland",
        category: "Terrasse & udeliv",
        year: "2025",
        summary:
            "En rummelig træterrasse med slat-værn og udsigt til mark og frugttræ — bygget til at holde mange somre.",
        description: [
            "Foråret er lige om hjørnet, og hos Fyr & Finér står vi klar til en ny sæson fyldt med udeprojekter. Her er et kig på en terrasse, vi har bygget op fra bunden — med rummelig plads til lounge, grill og ramper bag det slatede værn.",
            "Brædderne er lagt i lige, gennemgående linjer, og kanten er afsluttet med en ramme, der gemmer skæringerne. Værnet er bygget op af vandrette lægter, der filtrerer læ fra vinden uden at lukke for udsigten til marken og frugttræet.",
            "Drømmer I om en træterrasse, en hyggelig pergola, et praktisk haveskur — eller noget helt fjerde til udesæsonen? Så tag fat i os allerede nu. Kalenderen fyldes hurtigt op inden sommeren, og vi giver altid et uforpligtende tilbud.",
        ],
        cover: "https://customer-assets.emergentagent.com/job_markus-toemrer/artifacts/p5loy12z_645472837_122139776600995551_927334280733640220_n.jpg",
        gallery: [
            "https://customer-assets.emergentagent.com/job_markus-toemrer/artifacts/vb8j2z87_645313550_122139776594995551_4967570623069322047_n.jpg",
        ],
        facebookUrl: "https://web.facebook.com/share/p/17gVfndtvN/",
        instagramUrl: "https://www.instagram.com/fyrogfiner/",
        featured: true,
    },
    {
        slug: "solceller-have-tisvilde",
        title: "Solceller i haven",
        subtitle: "Tisvilde · Stativmonterede paneler",
        category: "Solceller & montage",
        year: "2025",
        summary:
            "Solceller opsat på stativ i haven i Tisvilde — en anderledes løsning, hvor tagflade ikke var en mulighed.",
        description: [
            "Fyr & Finér har sammen med tømrermester Emil Nordlund været en tur i Tisvilde, hvor vi opsatte solceller på stativ direkte i haven.",
            "En spændende og lidt anderledes opgave. Normalt monterer vi solceller på tag, men når orienteringen, skyggerne eller tagfladen ikke spiller med, er et frit-stående stativ en solid løsning. Stativet er bygget op, så det står fast — også når det blæser — og så panelerne får den rigtige hældning ind mod solen.",
            "Vil du også have en grønere hverdag og få mest muligt ud af solen? Så tag fat i os — vi hjælper dig gerne i gang med projektet, uanset om det skal på tag eller i haven.",
        ],
        cover: "https://customer-assets.emergentagent.com/job_markus-toemrer/artifacts/dzzm0pmb_564584618_122118845660995551_1907339500369129280_n.jpg",
        gallery: [
            "https://customer-assets.emergentagent.com/job_markus-toemrer/artifacts/nzzlx5k7_565130812_122118845624995551_3561012102072359756_n.jpg",
            "https://customer-assets.emergentagent.com/job_markus-toemrer/artifacts/nohye4ih_564551758_122118845654995551_4322423019970067698_n.jpg",
            "https://customer-assets.emergentagent.com/job_markus-toemrer/artifacts/kep72uch_560470468_122118845636995551_8570541481560654014_n.jpg",
            "https://customer-assets.emergentagent.com/job_markus-toemrer/artifacts/dvsb7ycp_561426475_122118845600995551_3750878525774612459_n.jpg",
        ],
        facebookUrl: "https://web.facebook.com/share/p/1CWrA71pmV/",
        instagramUrl: "https://www.instagram.com/fyrogfiner/",
        featured: true,
    },
    {
        slug: "franske-doere-gilleleje",
        title: "Eksklusiv forvandling med franske døre",
        subtitle: "Gilleleje · Indvendig montering",
        category: "Døre & vinduer",
        year: "2025",
        summary:
            "Smukke franske døre monteret i Gilleleje — lys, elegance og klassisk håndværk, der binder rummene sammen.",
        description: [
            "Fyr & Finér har været i Gilleleje og monteret et sæt smukke franske døre, der forvandler rummet med lys, elegance og klassisk håndværk.",
            "De nye døre skaber en harmonisk overgang mellem rummene og giver hjemmet et markant løft — både æstetisk og funktionelt. Hver detalje fra karmen til karmlisterne er tilpasset huset, så døren virker som om, den altid har stået der.",
            "Vi leverer og monterer kvalitetsdøre i mange stilarter, skræddersyet til dit hjem og dine ønsker. Ring for et uforpligtende tilbud på nye døre, vinduer eller andre tømreropgaver.",
        ],
        cover: "https://customer-assets.emergentagent.com/job_markus-toemrer/artifacts/b4i20go3_561071192_122118675860995551_614615798301298631_n.jpg",
        gallery: [
            "https://customer-assets.emergentagent.com/job_markus-toemrer/artifacts/jkgazl8o_565205425_122118675884995551_5043123756466198516_n.jpg",
            "https://customer-assets.emergentagent.com/job_markus-toemrer/artifacts/3g1mradl_564239406_122118675866995551_2242702244910597519_n.jpg",
        ],
        facebookUrl: "https://web.facebook.com/share/p/1DwL448tiA/",
        instagramUrl: "https://www.instagram.com/fyrogfiner/",
        featured: true,
    },
    {
        slug: "solceller-roskilde-fjord",
        title: "Solceller med udsigt",
        subtitle: "Roskilde · Udsigt over Roskilde Fjord",
        category: "Solceller & tag",
        year: "2025",
        summary:
            "Solceller lagt på fladt tagpap med udsigt over Roskilde Fjord — solidt håndværk kombineret med grøn energi.",
        description: [
            "En tur til Roskilde, hvor vi lagde solceller på det flade tag — med den flotteste udsigt over Roskilde Fjord man kan ønske sig som arbejdsplads.",
            "Fra klargøring af tagpappet og montering af alu-skinnerne til panelerne var på plads. Alt sammen udført, så både tagets tæthed og kablernes fremføring fungerer sammen i mange år fremover.",
            "Hos Fyr & Finér er vi stolte af at kunne kombinere solidt tømrerarbejde med grøn energi. Skal du også have solceller, nyt tag eller andet tømrerarbejde udført, så står vi klar. Alt andet er bare spån.",
        ],
        cover: "https://customer-assets.emergentagent.com/job_markus-toemrer/artifacts/rngj0lnq_558771895_122116389902995551_4562079032658687709_n.jpg",
        gallery: [
            "https://customer-assets.emergentagent.com/job_markus-toemrer/artifacts/q5dsy4iy_556826229_122116389884995551_1519421514941272863_n.jpg",
            "https://customer-assets.emergentagent.com/job_markus-toemrer/artifacts/dirw0qcx_558573445_122116389890995551_6456559248998334975_n.jpg",
            "https://customer-assets.emergentagent.com/job_markus-toemrer/artifacts/wt1p468n_556535213_122116389896995551_5187947710824447001_n.jpg",
        ],
        facebookUrl: "https://web.facebook.com/share/p/18VpawTgGE/",
        instagramUrl: "https://www.instagram.com/fyrogfiner/",
        featured: true,
    },
];

export const getProjectBySlug = (slug) =>
    projects.find((p) => p.slug === slug);

export const getFeaturedProjects = (limit = 4) =>
    projects.filter((p) => p.featured).slice(0, limit);
